import { render, staticRenderFns } from "./CustomersTimeline.vue?vue&type=template&id=3ba7e473&scoped=true"
import script from "./CustomersTimeline.vue?vue&type=script&lang=js"
export * from "./CustomersTimeline.vue?vue&type=script&lang=js"
import style0 from "./CustomersTimeline.vue?vue&type=style&index=0&id=3ba7e473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba7e473",
  null
  
)

export default component.exports